import almaLogo from 'url:../../../../../resource/images/logoAlma.png';
import cbVadLogo from 'url:../../../../../resource/images/3logos.png';

const EXTERNAL_CONTRACT_TYPES = {
    ALMA: { name: 'ALMA', creationType: 'apikey', logo: almaLogo },
    VAD: { name: 'CBVAD', creationType: 'apikey', logo: cbVadLogo }
};
EXTERNAL_CONTRACT_TYPES.DEFAULT = EXTERNAL_CONTRACT_TYPES.ALMA;

export default EXTERNAL_CONTRACT_TYPES;